import { M as MobileMode } from '../../MobileThemeProvider/MobileMode-DHJ6VHqt.js';

function isNotMobile(style) {
  return ({
    theme
  }) => {
    var _theme$mobile;
    const mode = theme === null || theme === void 0 || (_theme$mobile = theme.mobile) === null || _theme$mobile === void 0 ? void 0 : _theme$mobile.mode;
    if (mode === MobileMode.Auto) {
      return ['@media ', theme.mobile.inverseMediaQuery, '{', style, '}'];
    }
    if (mode === undefined || mode === MobileMode.Disable) {
      return [style];
    }
    return null;
  };
}

export { isNotMobile as i };
//# sourceMappingURL=isNotMobile-B9hACxZW.js.map
